import { createContext, useReducer } from "react";

//initialStates
import activarTotpInitialState from "./initialStates/activarTotpInitialState";
import checkActivoInitialState from "./initialStates/checkActivoInitialState";
import textosInitialState from "./initialStates/textosInitialState";

//reducers
import activarTotp from "./reducers/activarTotp";
import checkActivo from "./reducers/checkActivo";
import textos from "./reducers/textos";
import { RESET_CONTEXT } from "./ActionTypes";

export const SegundoFactorContext = createContext();

export const SegundoFactorProvider = ({ children }) => {
  const [activarTotpState, activarTotpDispatch] = useReducer(
    activarTotp,
    activarTotpInitialState
  );
  const [checkActivoState, checkActivoDispatch] = useReducer(
    checkActivo,
    checkActivoInitialState
  );
  const [textosState, textosDispatch] = useReducer(textos, textosInitialState);

  //RESET CONTEXT
  const arrayDispatch = [
    activarTotpDispatch,
    checkActivoDispatch,
    textosDispatch,
  ];

  const sessionStorageExclusion = [];
  const localStorageExclusion = ["config", "dtoSegundoFactor"];

  const limpiarStorage = (sessionExcepcion, localExcepcion) => {
    //limpiar sessionStorage
    if (Object.keys(sessionStorage).length > 0) {
      Object.keys(sessionStorage).map(
        (key) =>
          !sessionExcepcion.includes(key) && sessionStorage.removeItem(key)
      );
    }
    //limpiar localStorage
    if (Object.keys(localStorage).length > 0) {
      Object.keys(localStorage).map(
        (key) => !localExcepcion.includes(key) && localStorage.removeItem(key)
      );
    }
  };

  const resetSegundoFactorContext = (index) => {
    if (Array.isArray(arrayDispatch)) {
      if (index >= arrayDispatch.length) {
        limpiarStorage(sessionStorageExclusion, localStorageExclusion);
        return;
      }
      const dispatch = arrayDispatch[index];
      dispatch({ type: RESET_CONTEXT });
      resetSegundoFactorContext(index + 1);
    }
  };
  return (
    <SegundoFactorContext.Provider
      value={{
        activarTotpState,
        activarTotpDispatch,
        checkActivoState,
        checkActivoDispatch,
        textosState,
        textosDispatch,
        resetSegundoFactorContext,
      }}
    >
      {children}
    </SegundoFactorContext.Provider>
  );
};
